// frontend/pages/HrManagerDashboard.jsx
import React, { useState } from "react";
import PageHeader from "./PageHeader.jsx";
import {
  Users,
  Clock,
  Sun,
  CalendarDays,
  BarChart3,
} from "lucide-react";

import HrManagerEmployeesTab from "../components/HrManagerEmployeesTab.jsx";
import HrManagerTimeTab from "../components/HrManagerTimeTab.jsx";
import HrManagerVacationsTab from "../components/HrManagerVacationsTab.jsx";
import HrManagerWorkScheduleTab from "../components/HrManagerWorkScheduleTab.jsx";
import HrManagerReportsTab from "../components/HrManagerReportsTab.jsx";

import "../styles/hr/hr-manager-dashboard.css";

const HrManagerDashboard = () => {
  const [activeTab, setActiveTab] = useState("team");

  const tabs = [
    { id: "team", label: "Equipo", icon: Users },
    { id: "time", label: "Fichajes equipo", icon: Clock },
    { id: "vacations", label: "Vacaciones y ausencias", icon: Sun },
    { id: "workSchedule", label: "Horarios base", icon: CalendarDays },
    { id: "reports", label: "Reportes", icon: BarChart3 },
  ];

  const renderActiveTab = () => {
    if (activeTab === "team") return <HrManagerEmployeesTab />;
    if (activeTab === "time") return <HrManagerTimeTab />;
    if (activeTab === "vacations") return <HrManagerVacationsTab />;
    if (activeTab === "workSchedule") return <HrManagerWorkScheduleTab />;
    if (activeTab === "reports") return <HrManagerReportsTab />;
    return null;
  };

  return (
    <div className="hr-manager-dashboard">
      <div className="hr-manager-header">
        <div>
          <h1 className="hr-manager-title"><PageHeader title="Panel de manager" /></h1>
          <p className="hr-manager-subtitle">
            Gestiona equipo, fichajes, vacaciones, horarios base y reportes desde un único lugar.
          </p>
        </div>
      </div>

      <div className="hr-tabs" role="tablist">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              className={`hr-tab-button ${
                isActive ? "hr-tab-button--active" : ""
              }`}
              onClick={() => setActiveTab(tab.id)}
              role="tab"
              aria-selected={isActive}
            >
              <Icon className="hr-tab-icon" aria-hidden="true" />
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>

      <div className="hr-tab-content">{renderActiveTab()}</div>
    </div>
  );
};

export default HrManagerDashboard;